import ModelPerTypes from 'store/actionTypes/modelPer'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const modelPer = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case ModelPerTypes.GET_MODEL_PERS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case ModelPerTypes.GET_MODEL_PER_DETAIL_SUCCESS:
      return { ...state, current: payload }
    case ModelPerTypes.UPDATE_FILTER_MODEL_PER_SUCCESS:
      return { ...state, filter: payload }
    case ModelPerTypes.GET_SYSTEM_MODEL_PERS_SUCCESS:
      return {
        ...state,
        systems: payload?.modelPers?.items
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default modelPer
